import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=32c1623c&scoped=true&"
import script from "./Orders.js?vue&type=script&lang=js&"
export * from "./Orders.js?vue&type=script&lang=js&"
import style0 from "./Orders.scss?vue&type=style&index=0&id=32c1623c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1623c",
  null
  
)

export default component.exports